import * as yup from "yup";

export const BcEhtSetupValidationSchema = yup.object().shape({
  // departmentName: yup
  // .string()
  // .required("Department Name is required")
  // .min(1, "Minimum length 1 characters")
  // .max(50, "Maximum length 50 characters"),
	// notes: yup
  //   .string()
  //   .max(100, "Maximum length 100 characters"),
});
